import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { LandingPageSection } from 'src/app/landing-page.model';

@Component({
  selector: 'app-page-feature',
  templateUrl: './page-feature.component.html',
  styleUrls: ['./page-feature.component.scss']
})
export class PageFeatureComponent implements OnInit {

  @Input() data: LandingPageSection;
  @Input() desktopWidth: string = "1110";

  trustedFeatures: Array<Record<string, any>> = []

  constructor(
    private sanitiser: DomSanitizer,
  ) { }

  ngOnInit(): void {
    this.trustedFeatures = this.data.page_feature.map(f => {
      const newF = f;
      newF.trustedDesc = this.sanitiser.bypassSecurityTrustHtml(f.description);
      return newF;
    })
  }

}
